<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>{{isProfileImage ? 'Update Profile Picture' : 'Add Image'}}</h2>
    <button mat-icon-button type="button" fxLayoutAlign="end center"(click)="viewProfileImageHelp()">
        <mat-icon class="headerIconButton" aria-label="View Profile Image Help" matTooltip="View Profile Image Help">help</mat-icon>
    </button>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close()">
        <mat-icon aria-label="Close" matTooltip="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content class="profileDialogContent">
    <div class="actions">
        <!-- Hidden input -->
        <input #_fileInput type="file" (change)="cropping.selectInputEvent($event)" accept="image/*" hidden>
    </div>

    <div fxLayout="column">
        <div *ngIf="cropping.isLoaded" fxLayout="row" fxFlex="100%" class="displayBlock">
            <button (click)="_fileInput.click()" mat-icon-button matTooltip="Upload new image"><mat-icon>add_a_photo</mat-icon></button>
            <button (click)="cropping.zoomIn()" mat-icon-button matTooltip="Zoom In"><mat-icon>zoom_in</mat-icon></button>
            <button (click)="cropping.zoomOut()" mat-icon-button matTooltip="Zoom Out"><mat-icon>zoom_out</mat-icon></button>
            <button (click)="cropping.center()" mat-icon-button matTooltip="Center Image"><mat-icon>filter_center_focus</mat-icon></button>
            <button (click)="cropping.rotate(-90)" mat-icon-button matTooltip="Rotate"><mat-icon>rotate_90_degrees_ccw</mat-icon></button>
            <button (click)="cropping.fit()" mat-button class="cropActionButton">Fit</button>
            <button (click)="cropping.fitToScreen()" mat-button class="cropActionButton">Fit to screen</button>
            <button (click)="cropping.setScale(1)" mat-button class="cropActionButton" matTooltip="Original Size">1:1</button>
        </div>

        <div fxLayout="row" fxFlex="100%" *ngIf="profileImageRejectedReason" class="redBackground padding10">
            <span>{{profileImageRejectedReason}}</span>
        </div>

        <ly-img-cropper [ngClass]="{'cropping': isProfileImage, 'croppingLarge': !isProfileImage}" #cropping [config]="isProfileImage ? imageCropperConfig : imageCropperIdDocConfig" (cropped)="onImageCropped($event)" (error)="onImageCropError($event)" (ready)="onImageReady($event)">
            <span class="cursorPointer">Click to Upload Image</span>
        </ly-img-cropper>
    </div>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end center">
    <button class="mat-raised-button dialogActionButton" (click)="close()" mat-button>Cancel</button>
    <button class="mat-raised-button mat-primary dialogActionButton" [disabled]="!cropping.isLoaded" (click)="save()" mat-button>Add Image</button>
</mat-dialog-actions>